'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveAssetId } from 'DesignData/selectors/app';
import { getRawAssetDimensions } from 'DesignData/selectors/rawAssetBuffers';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';

const StatusBarFileDimensions = ({
  width,
  height
}) => {
  if (typeof width !== 'number' || typeof height !== 'number') return null;

  const label = /*#__PURE__*/_jsxs("span", {
    children: [width, " \xD7 ", height]
  });

  return /*#__PURE__*/_jsx(StatusBarSection, {
    label: label
  });
};

const mapStateToProps = state => {
  const dimensions = getRawAssetDimensions(state, {
    assetId: getActiveAssetId(state)
  });
  if (!dimensions) return {};
  const {
    width,
    height
  } = dimensions;
  return {
    width,
    height
  };
};

StatusBarFileDimensions.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};
export default connect(mapStateToProps, null)(StatusBarFileDimensions);